<template>
  <div class="passenger-form-row">
    <div class="passenger-item-title">
      <h3>旅客{{psgIndex+1}}</h3>
      <span v-if="initValue.passengerType==='ADT'">成人（≥12岁）</span>
      <span v-else-if="initValue.passengerType==='CHD'">儿童（2岁(含)-12岁）</span>
      <span v-else-if="initValue.passengerType==='INF'">婴儿（14天(含)-2岁）</span>
      <span>
        <a-checkbox :checked="isChecked" @change="setUsual($event, psgIndex)">设为常用人</a-checkbox>
      </span>
    </div>
    <div class="passenger-item-content">
      <div class="passenger-wrap clearfix">
        <a-form-item label="旅客Id" class="hidden">
          <a-input
            v-decorator="[
              `passengers[${psgIndex}].id`
            ]"
            size="large"
            hidden
          />
        </a-form-item>
        <a-form-item label="类型" class="hidden">
          <a-input
            v-decorator="[
              `passengers[${psgIndex}].passengerType`
            ]"
            size="large"
            hidden
          />
        </a-form-item>
        <a-form-item label="设为乘机人" class="hidden">
          <a-checkbox
            v-decorator="[
              `passengers[${psgIndex}].isUsual`
            ]"
            size="large"
            hidden
          ></a-checkbox>
        </a-form-item>
        <a-form-item label="姓名" class="hidden">
          <a-input
            v-decorator="[
              `passengers[${psgIndex}].fullName`,
              {
                rules: [
                  {
                    validator: handleFieldValidate
                  }
                ],
                validateTrigger: 'blur'
              }
            ]"
            size="large"
            placeholder="请输入姓名"
          />
        </a-form-item>
        <div class="field-outter">
          <a-form-item label="姓" required>
            <a-input
              v-decorator="[
                `passengers[${psgIndex}].passengerLastName`,
                {
                  rules: [
                    {
                      validator: handleFieldValidate
                    }
                  ],
                  validateTrigger: 'blur',
                  normalize: (value) => {
                    return value && value.toUpperCase()
                  }
                }
              ]"
              @change="setFullName"
              size="large"
              placeholder="拼音或英文姓"
            />
            <passenger-tooltip v-if="getPassengerFieldInfo('lastNameInt')" :data="getPassengerFieldInfo('lastNameInt')"></passenger-tooltip>
          </a-form-item>
        </div>
        <div class="field-outter">
          <a-form-item label="名" required>
            <a-input
              v-decorator="[
                `passengers[${psgIndex}].passengerFirstName`,
                {
                  rules: [
                    {
                      validator: handleFieldValidate
                    }
                  ],
                  validateTrigger: 'blur',
                  normalize: (value) => {
                    return value && value.toUpperCase()
                  }
                }
              ]"
              @change="setFullName"
              size="large"
              placeholder="拼音或英文名"
            />
            <passenger-tooltip v-if="getPassengerFieldInfo('firstNameInt')" :data="getPassengerFieldInfo('firstNameInt')"></passenger-tooltip>
          </a-form-item>
        </div>
        <div class="field-outter">
          <a-form-item label="性别" required>
            <a-select
              v-decorator="[
                `passengers[${psgIndex}].gender`,
                {
                  rules: [
                    {
                      validator: handleFieldValidate
                    }
                  ],
                  validateTrigger: 'change'
                }
              ]"
              size="large"
              placeholder="请选择性别"
            >
              <a-select-option value="M">男</a-select-option>
              <a-select-option value="F">女</a-select-option>
            </a-select>
          </a-form-item>
        </div>
        <div class="field-outter" v-if="initValue.passengerType==='INF'">
          <a-form-item label="婴儿携带人" required>
            <a-select
              v-decorator="[
                `passengers[${psgIndex}].adultName`,
                {
                  rules: [
                    {
                      validator: handleFieldValidate
                    }
                  ],
                  validateTrigger: 'change'
                }
              ]"
              @focus="getAdultList"
              size="large"
              placeholder="请选择婴儿携带人"
            >
              <a-select-option v-for="adult in adultOptionList" :key="adult">{{adult}}</a-select-option>
            </a-select>
          </a-form-item>
        </div>
        <div class="field-outter" v-if="initValue.passengerType!=='INF'">
          <a-form-item label="证件类型" required>
            <a-select
              v-decorator="[
                `passengers[${psgIndex}].idType`,
                {
                  rules: [
                    {
                      validator: handleFieldValidate
                    }
                  ],
                  validateTrigger: 'change'
                }
              ]"
              size="large"
              placeholder="请选择证件类型"
              defaul-value="PP"
            >
              <a-select-option value="PP">护照</a-select-option>
              <a-select-option value="ID1">港澳通行证</a-select-option>
              <a-select-option value="ID2">大陆居民往来台湾通行证</a-select-option>
              <a-select-option value="ID11">港澳居民来往内地通行证</a-select-option>
              <a-select-option value="ID12">台湾居民来往大陆通行证</a-select-option>
            </a-select>
            <passenger-tooltip v-if="getPassengerFieldInfo('idTypeInt')" :data="getPassengerFieldInfo('idTypeInt')"></passenger-tooltip>
          </a-form-item>
        </div>
        <div class="field-outter field-long" v-if="initValue.passengerType!=='INF'">
          <a-form-item label="证件号码" required>
            <a-input
              v-decorator="[
                `passengers[${psgIndex}].certificateNo`,
                {
                  rules: [
                    {
                      validator: handleFieldValidate
                    }
                  ],
                  validateTrigger: 'blur'
                }
              ]"
              size="large"
              placeholder="请输入证件号码"
            />
          </a-form-item>
        </div>
        <a-form-item label="出生日期" class="hidden">
          <a-input
            v-decorator="[
              `passengers[${psgIndex}].birthday`
            ]"
            size="large"
            hidden
          />
        </a-form-item>
        <div class="field-outter">
          <a-form-item label="出生日期" required>
            <a-date-picker
              v-decorator="[
                `passengers[${psgIndex}].birthdayObj`,
                {
                  rules: [
                    {
                      validator: handleFieldValidate
                    }
                  ],
                  validateTrigger: 'change'
                }
              ]"
              size="large"
              placeholder="请输入出生日期"
            />
          </a-form-item>
        </div>
        <div class="field-outter">
          <a-form-item label="国籍" required>
            <a-select
              v-decorator="[
                `passengers[${psgIndex}].nationality`,
                {
                  rules: [
                    {
                      validator: handleFieldValidate
                    }
                  ],
                  validateTrigger: 'change'
                }
              ]"
              size="large"
              show-search
              :filter-option="filterOption"
              :options="renderedOptions"
              placeholder="请选择国籍"
              v-model="selectedVal"
              @search="handleSearch"
              @popupScroll="handlePopupScroll"
              @select="handleSelect"
            >
            </a-select>
          </a-form-item>
        </div>
        <div class="field-outter" v-if="initValue.passengerType!=='INF'">
          <a-form-item label="证件签发国" required>
            <a-select
              v-decorator="[
                `passengers[${psgIndex}].issueCountry`,
                {
                  rules: [
                    {
                      validator: handleFieldValidate
                    }
                  ],
                  validateTrigger: 'change'
                }
              ]"
              size="large"
              show-search
              :filter-option="filterOption"
              :options="renderedOptions"
              placeholder="请选择证件签发国"
              v-model="selectedVal"
              @search="handleSearch"
              @popupScroll="handlePopupScroll"
              @select="handleSelect"
            >
            </a-select>
          </a-form-item>
        </div>
        <a-form-item label="证件有效期" class="hidden">
          <a-input
            v-decorator="[
              `passengers[${psgIndex}].certExpried`
            ]"
            size="large"
            hidden
          />
        </a-form-item>
        <div class="field-outter" v-if="initValue.passengerType!=='INF'">
          <a-form-item label="证件有效期" required>
            <a-date-picker
              v-decorator="[
                `passengers[${psgIndex}].certExpriedObj`,
                {
                  rules: [
                    {
                      validator: handleFieldValidate
                    }
                  ],
                  validateTrigger: 'change'
                }
              ]"
              size="large"
              placeholder="请输入证件有效期"
              :disabled-date="startDisabledDate"
              :default-picker-value="startDate(departureDate)"
              :showToday="false"
              format="YYYY-MM-DD"
            />
            <passenger-tooltip v-if="getPassengerFieldInfo('certExpried')" :data="getPassengerFieldInfo('certExpried')"></passenger-tooltip>
          </a-form-item>
        </div>
        <div class="field-outter field-long contact-mobile" v-if="initValue.passengerType==='ADT'">
          <a-form-item label="手机号码" required>
            <a-input
              v-decorator="[
                `passengers[${psgIndex}].mobile`,
                {
                  rules: [
                    {
                      validator: handleFieldValidate
                    }
                  ],
                  validateTrigger: 'blur'
                }
              ]"
              size="large"
              placeholder="请输入手机号码"
            >
              <a-select
                class="counrty-code-select"
                showSearch
                slot="addonBefore"
                :dropdownMatchSelectWidth="false"
                :filterOption="countryCodefilter"
                :options="countryCodeList"
                optionLabelProp="value"
                v-decorator="[
                  `passengers[${psgIndex}].areaCode`,
                  { initialValue: '86' }
                ]"
              >
              </a-select>
            </a-input>
          </a-form-item>
        </div>
      </div>
       <div v-if="isNorthAmericaSegment" class="passenger-extra-wrap clearfix">
          <h4 class="flex-hc-vc mb-10">--前往美国和加拿大乘客必填--</h4>
          <h5 class="mb-10">目的地暂住地址 （请务必填写英文地址，并且不能使用任何标点符号）</h5>
          <div class="passenger-extra-main">
            <div class="field-outter">
              <a-form-item label="北美航线信息Id" class="hidden">
                <a-input
                  v-decorator="[
                    `passengers[${psgIndex}].destId`
                  ]"
                  size="large"
                  hidden
                />
              </a-form-item>
              <a-form-item label="国家、州/省" required>
                <a-cascader
                  :field-names="{ label: 'name', value: 'code', children: 'sonList' }"
                  :options="dictionaryList"
                  placeholder="请选择国家、州/省"
                  v-decorator="[
                    `passengers[${psgIndex}].countryAndStateCodeMix`,
                    {
                      initialValue: [],
                      rules: [
                        {
                          type: 'array',
                          validator: handleFieldValidate
                        }
                      ],
                      validateTrigger: 'change'
                    }
                  ]"
                />
              </a-form-item>
            </div>
            <!-- <div class="field-outter">
              <a-form-item label="省/州">
                <a-input
                  v-decorator="[
                    `passengers[${psgIndex}].countryCode`,
                    {
                      rules: [
                        {
                          validator: handleFieldValidate
                        }
                      ],
                      validateTrigger: 'blur'
                    }
                  ]"
                  size="large"
                  placeholder="请输入姓名"
                />
              </a-form-item>
            </div> -->
            <div class="field-outter">
              <a-form-item label="城市" required>
                <a-input
                  v-decorator="[
                    `passengers[${psgIndex}].city`,
                    {
                      rules: [
                        {
                          validator: handleFieldValidate
                        }
                      ],
                      validateTrigger: 'blur'
                    }
                  ]"
                  size="large"
                  placeholder="请输入城市"
                />
              </a-form-item>
            </div>
            <div class="field-outter">
              <a-form-item label="街道" required>
                <a-input
                  v-decorator="[
                    `passengers[${psgIndex}].street`,
                    {
                      rules: [
                        {
                          validator: handleFieldValidate
                        }
                      ],
                      validateTrigger: 'blur'
                    }
                  ]"
                  size="large"
                  placeholder="请输入街道"
                />
              </a-form-item>
            </div>
            <div class="field-outter">
              <a-form-item label="邮政编码" required>
                <a-input
                  v-decorator="[
                    `passengers[${psgIndex}].zipCode`,
                    {
                      rules: [
                        {
                          validator: handleFieldValidate
                        }
                      ],
                      validateTrigger: 'blur'
                    }
                  ]"
                  size="large"
                  placeholder="请输入邮政编码"
                />
              </a-form-item>
            </div>
          </div>

        </div>
    </div>
  </div>
</template>
<script>
import { debounce } from 'lodash'
import moment from 'moment'
import passengerTooltip from '@/components/tooltip/passenger-tooltip'
const LOAD_NUM = 20

export default {
  name: 'passengerItem',
  props: {
    initValue: { type: Object },
    psgIndex: { type: Number },
    adultList: { type: Array },
    oriDataList: { type: Array },
    departureDate: [Date, String],
    dictionaryList: { type: Array },
    passengerFieldInfo: { type: Array },
    isNorthAmericaSegment: { type: Boolean, default: false }
  },
  components: {
    passengerTooltip
  },
  watch: {
    adultList (value) {
      this.adultOptionList.length = 0
      for (let i = 0; i < value.length; i++) {
        this.adultOptionList.push(value[i])
      }
    },
    oriDataList: {
      handler () {
        this.updateData()
      },
      immediate: true
    }
  },
  data () {
    return {
      isChecked: true,
      countryCodeList: [],
      adultOptionList: [],
      intFormTipsImage: require('../image/int_form_tips.png'),
      selectedVal: '', // Select框选中的值
      searchVal: '', // 搜索的内容
      filterDataList: [], // 过滤的数据列表 -- 从dataList中过滤出含搜索内容的数据
      renderedOptions: [], // 已渲染的下拉列表
      moment
    }
  },
  mounted () {
    this.isChecked = this.initValue.isUsual
    // 异步加载，代码分离
    require.ensure([], (require) => {
      this.countryCodeList = require('@/assets/js/countrycode').default
    })
  },
  methods: {
    startDate (departureDate) {
      return departureDate ? moment(departureDate).add(6, 'months') : null
    },
    startDisabledDate (current) {
      const { departureDate } = this
      return current && departureDate && current < moment(departureDate).endOf('day').add(6, 'months')
    },
    updateData () {
      this.renderedOptions = this.oriDataList.slice(0, LOAD_NUM)
    },
    handleFieldValidate (rule, value, callback) {
      this.$emit('inputItemValide', rule.fullField, value, callback)
    },
    setUsual (e, index) {
      this.isChecked = e.target.checked
      this.$emit('setUsual', this.isChecked, index)
    },
    setFullName (item = {}) {
      const { psgIndex } = this
      const { id, value } = item.target
      this.$emit('setFullName', { id, value }, psgIndex)
    },
    countryCodefilter (input, option) {
      return option.data?.attrs?.data.toLowerCase().indexOf(input) >= 0
    },
    getAdultList () {
      this.$emit('getAdultList', name)
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    getPassengerFieldInfo (type) {
      const { passengerFieldInfo = [] } = this
      const data = passengerFieldInfo.find(item => { return item?.label === type }) || null
      return data
    },
    // 懒加载优化 select 数据过大产生的卡顿
    // 文本框值变化时触发 -- 从数据源中过滤出含搜索内容的数据，并取过滤结果的前n条作为下拉列表的可选项
    handleSearch (val) {
      const { oriDataList } = this
      const filterList = val ? oriDataList.filter(item => { return item.label.indexOf(val) > -1 }) : oriDataList
      this.searchVal = val
      this.filterDataList = filterList
      this.renderedOptions = filterList.length < LOAD_NUM ? filterList : filterList.slice(0, LOAD_NUM)
    },

    // 滚动时触发（防止抖动）
    handlePopupScroll: debounce(function () {
      const { searchVal, oriDataList, filterDataList } = this
      this.loadMoreData(searchVal === '' ? oriDataList : filterDataList)
    }, 400),

    // 加载更多数据到select框
    loadMoreData (dataList) {
      const renderedLen = this.renderedOptions.length // 已渲染的下拉列表长度
      const totalLen = dataList.length // 当前数据源的长度
      if (renderedLen < totalLen) {
        const addList = renderedLen + LOAD_NUM <= totalLen
          ? dataList.slice(renderedLen, renderedLen + LOAD_NUM)
          : dataList.slice(renderedLen, renderedLen + (totalLen % LOAD_NUM))
        this.renderedOptions = (this.renderedOptions).concat(addList)
      }
    },

    // 被选中时调用，参数为选中项的 value (或 key) 值
    handleSelect (val) {
      if (this.searchVal) {
        const selectedArr = this.oriDataList.filter(item => item.value === val) // 从数据源中过滤出下拉框选中的值，并返回一个数组
        const restList = this.oriDataList.filter(item => item.value !== val) // 从数据源中过滤出其他的值，返回一个数组
        const newList = selectedArr.concat(restList).slice(0, LOAD_NUM) // 将选中的元素放到下拉列表的第一位
        this.renderedOptions = newList // 更新已渲染的下拉列表
        this.searchVal = '' // 因为触发handleSelect函数时，会自动清空用户输入的内容。因此，searchVal需要重置。
      } else {
        this.renderedOptions = this.oriDataList.slice(0, LOAD_NUM)
      }
    }
  }
}
</script>
<style lang="less">
@import "formStyle";
</style>
